import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { Form, Offcanvas } from "react-bootstrap";
import '../../assets/css/Leads.css'
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

const DeliveriesQueue = () => {
  const [leads, setLeads] = useState([]);
  const [deliveryBoy, setDeliveryBoy] = useState([]);
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(50); const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDeliveryBoy, setSelectedDeliveryBoy] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const [show, setShow] = useState(false);
  const [completeDetails, setCompleteDetails] = useState("");
  const imageUrl = "https://devapi.bykit.in/storage/users/";


  const [delivery_assigned_to, setdelivery_assigned_to] = useState(null);
  const [latitude, setlatitude] = useState(null);
  const [longitude, setlongitude] = useState(null);
  const [did, setdid] = useState(null);
  const [showModal1, setShowModal1] = useState(false);


  const [formData, setFormData] = useState({
    price: "",
    details: "",
    pickup_type: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  let formattedPickupTime = ''
  if (selectedLead && selectedLead.pickup_time) {
    const pickup = new Date(selectedLead.pickup_time);
    formattedPickupTime = `${String(pickup.getDate()).padStart(2, '0')}-${String(pickup.getMonth() + 1).padStart(2, '0')}-${pickup.getFullYear()} ${String(pickup.getHours()).padStart(2, '0')}:${String(pickup.getMinutes()).padStart(2, '0')}`;
  }

  let formattedreachedTime = ''
  if (selectedLead && selectedLead.reached_workshop_time) {
    const reached = new Date(selectedLead.reached_workshop_time);
    formattedreachedTime = `${String(reached.getDate()).padStart(2, '0')}-${String(reached.getMonth() + 1).padStart(2, '0')}-${reached.getFullYear()} ${String(reached.getHours()).padStart(2, '0')}:${String(reached.getMinutes()).padStart(2, '0')}`;
  }

  let formattestartTime = ''
  if (selectedLead && selectedLead.start_service_time) {
    const start = new Date(selectedLead.start_service_time);
    formattestartTime = `${String(start.getDate()).padStart(2, '0')}-${String(start.getMonth() + 1).padStart(2, '0')}-${start.getFullYear()} ${String(start.getHours()).padStart(2, '0')}:${String(start.getMinutes()).padStart(2, '0')}`;
  }

  let formattecompleteTime = ''
  if (selectedLead && selectedLead.service_complete_time) {
    const complete = new Date(selectedLead.service_complete_time);
    formattecompleteTime = `${String(complete.getDate()).padStart(2, '0')}-${String(complete.getMonth() + 1).padStart(2, '0')}-${complete.getFullYear()} ${String(complete.getHours()).padStart(2, '0')}:${String(complete.getMinutes()).padStart(2, '0')}`;
  }

  let formatteDropTime = ''
  if (selectedLead && selectedLead.drop_time) {
    const drop = new Date(selectedLead.drop_time);
    formatteDropTime = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()} ${String(drop.getHours()).padStart(2, '0')}:${String(drop.getMinutes()).padStart(2, '0')}`;
  }


  let insuranceexpiry = ''
  if (selectedLead && selectedLead.insurance_expiry_date) {
    const drop = new Date(selectedLead.insurance_expiry_date);
    insuranceexpiry = `${String(drop.getDate()).padStart(2, '0')}-${String(drop.getMonth() + 1).padStart(2, '0')}-${drop.getFullYear()}`;
  }

  const mapContainerStyle = { width: '100%', height: '350px' };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCxtuQLTtr6G4ai6Tz-DiwB-rPKho3iHSs"
  });

  const offcanvasRef = useRef(null);



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showOffcanvas &&
        offcanvasRef.current &&
        !offcanvasRef.current.contains(event.target)
      ) {
        setShowOffcanvas(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOffcanvas]);


  const handleAssign = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    const payload = {
      booking_id: selectedId,
      price: formData.price,
      details: formData.details,
      pickup_type: formData.pickup_type
    }
    console.log('assign astiment', payload)

    try {
      const response = await axios.post("https://devapi.bykit.in/api/admin/addestimation", payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

      console.log('addestiment', response)

      if (response.data.status === "RC200") {
        toast.success("Estimation added successfully!", { position: "top-right" });
        setShow(false);

        setFormData({
          price: "",
          details: "",
          pickup_type: ""
        });
      } else {
        toast.error("Failed to add estimation. Try again.", { position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding estimation:", error);
      setShow(false);
    }
  };

  useEffect(() => {

    let interval;

    if (showModal1) {
      // Start the interval to call the API every 30 seconds
      interval = setInterval(() => {
        get_rider_location(did); // Fetch the rider location every 30 seconds
      }, 10000); // 30 seconds interval
    } else {
      // Clear the interval if showModal1 is false
      clearInterval(interval);
    }

    // Cleanup interval when the component unmounts or showModal1 changes
    return () => {
      clearInterval(interval);
    };
  }, [showModal1]); // Effect runs when showModal1 changes


  const center = useMemo(() => {
    return {
      lat: parseFloat(latitude),
      lng: parseFloat(longitude),
    };
  }, [latitude, longitude]);




  const get_rider_location = async (id) => {
    setdid(id);
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/users/get_rider_location/` + id + `??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data && response.data.data) {
        setlatitude(response.data.data.latitude);
        setlongitude(response.data.data.longitude);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const labels = [
    "Meter",
    "Front Angle",
    "Right angle",
    "Left angle",
    "Back side",
    "Any dent/scratches"
  ];



  const [showInvoice, setShowInvoice] = useState(false);
  const [invoiceData, setInvoiceData] = useState({
    invoiceFile: null,
    invoiceAmount: "",
  });

  // Handle Input Changes
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setInvoiceData((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };


  const handleDetailsChange = (e) => {
    setCompleteDetails(e.target.value);
  };

  // Handle Form Submission
  const handleInvoiceSubmit = async (e) => {
    e.preventDefault();
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    if (!invoiceData.invoiceFile || !invoiceData.invoiceAmount) {
      alert("Please fill all fields and upload a valid PDF invoice.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("id", selectedId);
    formDataToSend.append("invoice", invoiceData.invoiceFile);
    formDataToSend.append("completed_details", completeDetails);
    formDataToSend.append("invoice_amount", invoiceData.invoiceAmount);

    console.log('formDataToSend', formDataToSend)

    try {
      const response = await axios.post(
        "https://devapi.bykit.in/api/admin/addinvoice??type=live",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('invoice upload', response)

      if (response.data.status === "RC200") {
        toast.success("Invoice uploaded successfully!");
        setShowInvoice(false);
        getLeadsData();
        getData();
      } else {
        toast.error("Failed to upload invoice. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading invoice:", error);

    }
  };



  const handleSubmit = async () => {

    if (!selectedDeliveryBoy || !selectedLead) {
      alert("Please select a delivery boy and a valid lead!");
      return;
    }

    if (delivery_assigned_to != -1) {

      const confirmChange = window.confirm("Are you sure you want to change delivery boy?");
      if (!confirmChange) return; // cancel if user says "No"
    }

    const deliveryBoyId = selectedDeliveryBoy;

    console.log("Assigning Delivery Boy ID:", deliveryBoyId);
    console.log("Lead ID:", selectedId);

    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/assign-delivery-boy/${selectedId}/${deliveryBoyId}??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("response", response)

      if (response.data.status === "RC200") {
        toast.success('Delivery boy assigned successfully')
        setShowModal(false);
        getLeadsData(); // Refresh the data
        getData();
      } else {
        toast.success('Failed to assign delivery boy')
      }
    } catch (error) {
      console.error("Error assigning delivery boy:", error);
    }
  };


  const getData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/delivery-boys/list?start=${(page - 1) * rowsPerPage}&length=${rowsPerPage}&?type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log('Delivery Boys', response.data)

      if (response.data && response.data.data) {
        setDeliveryBoy(response.data.data);
        setTotalRows(response.data.recordsTotal || 0);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const getLeadsData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;



    try {

      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/get-pending-pickup-drop-vehicles?start=0&length=100&?type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );


      console.log('get-pending-pickup-drop-vehicles', response.data)

      if (response.data && response.data.data) {
        setLeads(response.data.data);
        setTotalRows(response.data.recordsTotal || 0);
        setCompleteDetails(response.data.data[0].completed_details || "");
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handlePageChange = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (newRows) => {
    setRowsPerPage(newRows);
    setPage(1);
  };

  let formattedDate = '';
  if (selectedLead) {
    const dateObj = new Date(selectedLead.service_date);
    formattedDate = `${String(dateObj.getDate()).padStart(2, '0')}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${dateObj.getFullYear()}`;
  }



  const handleOpenModal = (lead, delivery_assigned_to) => {
    console.log("Lead selected:", lead);
    setSelectedId(lead);
    setSelectedLead(lead);
    setShowModal(true);
    setSelectedDeliveryBoy(delivery_assigned_to)

    setdelivery_assigned_to(delivery_assigned_to);
  };

  const assignModelOpen = (lead) => {
    setSelectedId(lead);
    setShow(true)
  }
  const invoiceModelOpen = (lead, details) => {
    setSelectedId(lead);
    setShowInvoice(true)
    setCompleteDetails(details);
  }
  const handleShowDetails = (lead) => {
    setSelectedLead(lead);
    setShowOffcanvas(true);
  };

  useEffect(() => {

    getLeadsData();
    getData();

    // Set up interval to call it every 10 minutes (600,000 milliseconds)
    const intervalId = setInterval(() => {
      getLeadsData();
    }, 120000); // 10 minutes in milliseconds
    return () => clearInterval(intervalId);


  }, []);

  const columns = [
    {
      name: "Created Date",
      cell: (row) => (
        <div className="">
          {row.date || "N/A"}
          {/* {
            row.status === 7
              ? '<button className="btn droppickup_btn mt-1">Service Started</button>'
              : row.status === 6
                ? '<button className="btn droppickup_btn mt-1">Approved</button>'
                : row.status === 2
                  ? '<button className="btn droppickup_btn mt-1">Assigned (Delivery)</button>'
                  : ''
          } */}
        </div>
      ),
      sortable: true,
    },

    {
      name: "Service Date",
      selector: (row) => {
        if (!row.service_date) return "N/A";

        const date = new Date(row.service_date);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
      },
      sortable: true,
      width: "170px"
    },


    {
      name: "Customer Name", selector: (row) => (
        <>
          {row.customer_name || "N/A"}
          <br />
          {row.phone || ""}
        </>
      ), sortable: true,
    },
    { name: "Vehicle Number", selector: (row) => row.vehicle_name || "N/A", sortable: true, },
    {
      name: "Address",
      cell: (row) => (
        <div className="">
          {row.address || "-"}


          {row.pickup_boy_name && <p><span style={{ fontWeight: 'bold' }}>Pickup Boy:</span> {row.pickup_boy_name}</p>}
          {row.delivery_boy_name && <p><span style={{ fontWeight: 'bold' }}>Delivery Boy:</span> {row.delivery_boy_name}</p>}
          {row.dropoff_boy_name && <p><span style={{ fontWeight: 'bold' }}>Dropoff Boy:</span> {row.dropoff_boy_name}</p>}


        </div>
      ),
      sortable: true,
      width: "260px",
    },
    {
      name: "Pickup/Drop",
      cell: (row) => {
        let buttonText = "N/A";

        if (row.pickup_drop_facility === 0) {
          buttonText = "Pickup";
        } else if (row.pickup_drop_facility === 3) {
          buttonText = "Self Pickup/Drop";
        } else if (row.pickup_drop_facility === 1) {
          buttonText = "Drop";
        } else if (row.pickup_drop_facility === 2) {
          buttonText = "Pickup & Drop";
        }

        return (
          <div>
            <button className="btn droppickup_btn mb-1">
              {buttonText}
            </button><br />



            {row.delivery_complete_photo && row.delivery_complete_photo.trim() !== "" ? (
              <div style={{ fontSize: "13px", color: "green" }}>
                Delivery Completed
              </div>
            ) : row.receive_photo && row.receive_photo.trim() !== "" ? (
              <div style={{ fontSize: "13px", color: "green" }}>
                Pickup Completed
              </div>
            ) : null}




            <>
              {row.expected_pickuptime && (
                <div>
                  Pickup Time (By Client): {row.expected_pickuptime}
                </div>
              )}
              {row.pickupdrop_price && (
                <div>
                  Pickup Charges: {row.pickupdrop_price}
                </div>
              )}

                {row.payment_status == 1 &&(
                <div style={{ fontSize: "13px", color: "green" }}>
                    Payment Completed
                </div>
              )}



            </>

          </div>
        );
      },
      sortable: true,
    }
    ,
    {
      name: "Left for Pickup",
      selector: (row) => {
        return row.deliveryboy_status == 1 ? 'Yes' : 'No';
      },
      sortable: true,
    },
    {
      name: "Action",
      cell: (row, index) => (

        <div className="d-flex  align-items-end">
          {/* Assign Delivery Button      flex-column      */}
          {row.status != 16 && row.status != 11 && row.status != 13 && row.estimation_status == 1 && (
            <button className="edit_btn me-2"
              data-tooltip-id={`assign-tooltip-${row.id}`}
              data-tooltip-content="Assign Delivery Boy"

              onClick={() => handleOpenModal(row.id, row.delivery_assigned_to)}
            >
              {/* icon here */}
              <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
                <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path>
              </svg>
            </button>

          )}

          {/* Estimation Status */}
          {/* {row.status === 14 && row.estimation_status == 0 && (
            <p>Your estimate is currently pending acceptance</p>
          )}

          {row.status === 14 && row.estimation_status == 1 && (
            <p>Estimation accepted</p>
          )} */}

          {/* View Details Button */}
          <button className="edit_btn me-2"
            data-tooltip-id={`view-tooltip-${row.id}`}
            data-tooltip-content="View Details"
            onClick={() => handleShowDetails(row)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" className="me-1 iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24">
              <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                <path d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178c.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178"></path>
                <path d="M15 12a3 3 0 1 1-6 0a3 3 0 0 1 6 0"></path>
              </g>
            </svg>
          </button>
          <Tooltip id={`view-tooltip-${row.id}`} place="top" className="tooltip_bg" />

          <Tooltip id={`assign-tooltip-${row.id}`} place="top" className="tooltip_bg" />

          {/* View Location */}
          {row.delivery_assigned_to !== -1 && latitude && (
            <button
              className="workshop_btn"
              onClick={() => {
                get_rider_location(row.delivery_assigned_to);
                setShowModal1(true);
              }}
            >
              View Location
            </button>
          )}
        </div>

      ),
    },
  ];



  return (
    <div className="container data-table-container p-2">
      <ToastContainer></ToastContainer>
      <div className="d-flex align-items-center gap-3">
        <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
        </svg>

        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
        </svg>

        <p className="m-0">Deliveries Queue</p>
      </div>
      <div className='managebrand_box mt-3 mb-2 pt-4 pb-1'>
        <div>
          <h4 className='dashboard_head ps-3 pb-4'>Deliveries Queue</h4>
        </div>
        <hr></hr>
        <div className="d-flex justify-content-between mt-3 px-3">
          {/* <div>
            <Form.Select
              className="per-page-dropdown w-20"
              value={rowsPerPage}
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              <option value={50}>50</option>
<option value={100}>100</option>
              <option value={200}>200</option>
              <option value={300}>300</option>
              <option value={400}>400</option>
            </Form.Select>
          </div> */}
          <div>
            <input
              type="text"
              placeholder="Search keyword"
              className="search-input"
              style={{ padding: '8px' }}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <DataTable
          columns={columns}
          data={leads
            .filter((item) => item.pickupdrop_status === 1)
            .filter((item) => item.customer_name && item.customer_name.toLowerCase().includes(search.toLowerCase()))
          }
          pagination
          responsive
          // paginationServer
          //paginationTotalRows={totalRows}
          paginationPerPage={rowsPerPage}
          paginationRowsPerPageOptions={[50, 100, 200, 300, 400]}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          customStyles={{
            headRow: { style: { backgroundColor: "#E2E8F0", color: "#475569", fontWeight: "bold" } },
            pagination: { style: { borderTop: "1px solid #ddd", padding: "10px", backgroundColor: "#f8f9fa" } },
            cells: {
              style: {
                padding: "5px",
                margin: "0",
              },
            },
            headCells: {
              style: {
                padding: "10px",
                margin: "0",
              },
            },
          }}
        />
      </div>

      <div>
        <Offcanvas className="custom-offcanvas" show={showOffcanvas} onHide={() => setShowOffcanvas(false)} placement="end">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body ref={offcanvasRef}>
            {selectedLead && (
              <div className="lead-details" ref={offcanvasRef}>

                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Service Details</h4>
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                    <h4 className="detail_title">Customer Details</h4>
                  </div>
                </div>
                <hr style={{ marginBottom: 10, marginTop: 10 }} />

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Date</h4>
                        <p className="detail_text">{selectedLead.date}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Type</h4>
                        <p className="detail_text">
                          {selectedLead.service_type === 0
                            ? `Free / ${selectedLead.free_service_no} Free Service`
                            : 'Paid'}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Name</h4>
                        <p className="detail_text">{selectedLead.customer_name}-{selectedLead.phone}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Vehicle Number:</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">

                      <div className="col-4">
                        <h4 className="detail_title">Total Amount</h4>
                        <p className="detail_text">{selectedLead.total_amount || "-"}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Payment Status</h4>
                        <p className="detail_text">{selectedLead.payment_status === 1 ? "Paid" : "Unpaid"}</p>
                      </div>

                      <div className="col-4">
                        {selectedLead.invoice ?
                          <div>
                            <h4 className="detail_title">Invoice</h4>
                            <p className="detail_text"> <Link
                              to={'https://devapi.bykit.in/storage/brands/' + `${selectedLead.invoice}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              View Invoice
                            </Link></p></div> : null
                        }
                      </div>

                    </div>
                  </div>

                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Address</h4>
                        <p className="detail_text">{selectedLead.address}</p>
                      </div>

                    </div>
                  </div>
                </div>



                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/Drop</h4>
                        <div className="mt-2">
                          <span className="btn droppickup_btn btn-sm">
                            {selectedLead?.pickup_drop_facility === 0
                              ? "Pickup"
                              : selectedLead?.pickup_drop_facility === 3
                                ? "Self Pickup/Drop"
                                : selectedLead?.pickup_drop_facility === 1
                                  ? "Drop"
                                  : "Pickup & Drop"}
                          </span>
                        </div>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup/drop Charges </h4><br />
                        <p className="detail_text">{selectedLead.pickupdrop_price ? selectedLead.pickupdrop_price : 'N/A'}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">

                      </div>
                      <div className="col-6">

                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Time</h4>
                        <p className="detail_text">{formattedPickupTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Pickup Images</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.pickup_photos && selectedLead.pickup_photos.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title">Vehicle Details</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-4">
                        <h4 className="detail_title">Vehicle Number</h4>
                        <p className="detail_text">{selectedLead.vehicle_name}</p>
                      </div>
                      <div className="col-4">
                        <h4 className="detail_title">Brand</h4>
                        <p className="detail_text">  {selectedLead?.brand_logo && (
                          <img
                            src={selectedLead.brand_logo}
                            alt="Brand Logo"
                            style={{ width: 50, height: 50, objectFit: "contain", marginRight: 10 }}
                            onError={(e) => (e.target.style.display = "none")}
                          />
                        )}
                        </p>
                      </div>

                      <div className="col-4">
                        <h4 className="detail_title">Model</h4>
                        <p className="detail_text">{selectedLead.model_name}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Workshop Reaching Time</h4>
                        <p className="detail_text">{formattedreachedTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to workshop</h4>
                        <div className="d-flex flex-wrap">
                          {selectedLead.receive_photo && selectedLead.receive_photo.split(",").map((photo, index) => (
                            <div style={{ fontSize: 12, width: '45%' }}>
                              {labels[index] || `Photo ${index + 1}`}
                              <Link
                                key={index}
                                to={`${imageUrl}${photo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ marginRight: 10 }}
                              >
                                <img
                                  src={`${imageUrl}${photo}`}
                                  alt=""
                                  className="pick_photo"
                                  onError={(e) => (e.target.style.display = "none")}
                                />
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Number</h4>
                        <p className="detail_text"> {selectedLead.insurance_number || "-"}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Insurance Company</h4>
                        <p className="detail_text"> {selectedLead.insurance_company || "-"}</p>
                      </div>
                    </div>
                  </div>
                </div>


                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Service Started Time</h4>
                        <p className="detail_text">{formattestartTime}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Service Complete Time</h4>
                        <p className="detail_text">{formattecompleteTime}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.insurance_copy_image ?
                        <div className="col-6">
                          <h4 className="detail_title">Insurance</h4>
                          <Link to={imageUrl + selectedLead.insurance_copy_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}
                      <div className="col-6">


                        <h4 className="detail_title">Insurance Expiry Date</h4>
                        <p className="detail_text">{insuranceexpiry != '01-01-1970' ? insuranceexpiry : "-"}</p>


                      </div>
                    </div>
                  </div>
                </div>








                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-6">
                        <h4 className="detail_title">Pickup from workshop</h4>
                        <p className="detail_text"> {selectedLead.work_complete_photo && selectedLead.work_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                      <div className="col-6">
                        <h4 className="detail_title">Drop to customer</h4>
                        <p className="detail_text">{selectedLead.delivery_complete_photo && selectedLead.delivery_complete_photo.split(",").map((photo, index) => (
                          <div style={{ fontSize: 12, width: '45%' }}>
                            {labels[index] || `Photo ${index + 1}`}
                            <Link
                              key={index}
                              to={`${imageUrl}${photo}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ marginRight: 10 }}
                            >
                              <img
                                src={`${imageUrl}${photo}`}
                                alt=""
                                className="pick_photo"
                                onError={(e) => (e.target.style.display = "none")}
                              />
                            </Link>
                          </div>
                        ))}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      {selectedLead.rc_book_image && selectedLead.rc_book_image != 'https://devapi.bykit.in/blank-image.png' ?
                        <div className="col-12">
                          <h4 className="detail_title">RC Book:</h4>
                          <Link to={imageUrl + selectedLead.rc_book_image} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>View Attachment</Link>
                        </div> : null}

                    </div>
                  </div>
                </div>




                <div className="row">
                  {/* First column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <div className="col-12">
                        <h4 className="detail_title">Drop Time</h4>
                        <p className="detail_text">{formatteDropTime}</p>
                      </div>
                      <div className="col-12">
                        <h4 className="detail_title">Message From Customer</h4>
                        <p className="detail_text">{selectedLead.message}</p>
                      </div>
                    </div>
                  </div>
                  {/* Second column */}
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                    <div className="row">
                      <h4 className="detail_title" style={{ marginTop: 30 }}>Ratings</h4>
                      <hr style={{ marginBottom: 10, marginTop: 10 }} />
                      <div className="col-6">
                        <h4 className="detail_title">Ratings for Delivery Boy </h4>{selectedLead.rate_delivaryboy && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_delivaryboy ? "star filled" : "star"}>
                            {i < selectedLead.rate_delivaryboy ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_delivaryboy ? <p className="detail_text">{selectedLead.comment_delivaryboy}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                      <div className="col-6">

                        <h4 className="detail_title">Ratings for Service</h4> {selectedLead.rate_workshop && Array.from({ length: 5 }, (_, i) => (
                          <span key={i} className={i < selectedLead.rate_workshop ? "star filled" : "star"}>
                            {i < selectedLead.rate_workshop ? '★' : '☆'}
                          </span>
                        ))}
                        {selectedLead.rate_workshop ? <p className="detail_text">{selectedLead.comment_workshop}</p> :
                          <p className="detail_text">No Rating given by User till now.</p>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Offcanvas.Body>
        </Offcanvas>
      </div>


      {/* Modal */}
      {showModal && (
        <div className="modal-overlay delete-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content delete-content " onClick={(e) => e.stopPropagation()}>
            <div className="modal-header bg-dark text-white mt-0">
              <h3>Assign Delivery Boy</h3>
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>

            <div className="p-3">
              <label className="form-label text-left">Delivery Boy</label>
              <select
                className="form-control form-select"
                value={selectedDeliveryBoy}
                onChange={(e) => setSelectedDeliveryBoy(e.target.value)}
              >
                <option value="" hidden>
                  Select a Delivery Boy
                </option>
                {deliveryBoy
                  .filter((boy) => boy.is_available && boy.status)
                  .map((boy) => (
                    <option key={boy.id} value={boy.id}>
                      {boy.name}
                    </option>
                  ))}
              </select>

            </div>


            <div className="d-flex justify-content-end mb-4 me-4">
              <button type="submit" className="btn submit_btn d-flex align-items-center gap-2" onClick={handleSubmit}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--ic"
                  width="1em"
                  height="1em"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor" d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2" ></path>
                </svg>
                <span>Submit</span>
              </button>
            </div>
          </div>
        </div>
      )}


      {show && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Estimation</h3>
                <button type="button" className="btn-close btn-close-white" onClick={() => setShow(false)}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAssign}>
                  <div className="mb-3">
                    <label className="form-label">Price</label>
                    <input
                      type="text"
                      name="price"
                      className="form-control"
                      value={formData.price}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <input
                      name="details"
                      className="form-control"
                      value={formData.details}
                      onChange={handleChange}
                      required ></input>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Pickup Type</label>
                    <input
                      type="text"
                      name="pickup_type"
                      className="form-control"
                      value={formData.pickup_type}
                      onChange={handleChange}
                      required />
                  </div>

                  <div className="d-flex justify-content-end  me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* ------------invoicemodel-------------------- */}


      {showInvoice && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal_width">
            <div className="modal-content">
              <div className="modal-header bg-dark">
                <h3 className="modal-title text-light">Add Invoice</h3>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowInvoice(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleInvoiceSubmit}>
                  {/* Invoice Upload Field */}
                  <div className="mb-3">
                    <label className="form-label">Upload Invoice (PDF)</label>
                    <input
                      type="file"
                      name="invoiceFile"
                      className="form-control"
                      // accept="application/pdf"
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  {/* Invoice Amount */}
                  <div className="mb-3">
                    <label className="form-label">Invoice Amount</label>
                    <input
                      type="text"
                      name="invoiceAmount"
                      className="form-control"
                      value={invoiceData.invoiceAmount}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Details</label>
                    <textarea
                      name="completeDetails"
                      className="form-control"
                      value={completeDetails} // Show API data
                      onChange={handleDetailsChange}
                      rows="4"
                    ></textarea>
                  </div>


                  {/* Submit Button */}
                  <div className="d-flex justify-content-end me-4">
                    <button type="submit" className="btn submit_btn d-flex align-items-center gap-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        role="img"
                        className="iconify iconify--ic"
                        width="1em"
                        height="1em"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="currentColor"
                          d="M17.59 3.59c-.38-.38-.89-.59-1.42-.59H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7.83c0-.53-.21-1.04-.59-1.41zM12 19c-1.66 0-3-1.34-3-3s1.34-3 3 3s3 1.34 3 3s-1.34 3-3 3m1-10H7c-1.1 0-2-.9-2-2s.9-2 2 2h6c1.1 0 2 .9 2 2s-.9 2-2 2"
                        ></path>
                      </svg>
                      <span>Submit</span>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}






      {showModal1 && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal1(false)}></button>
            </div>
            <div className='p-3'>
              {isLoaded && latitude ? (
                <GoogleMap
                  mapContainerStyle={mapContainerStyle}
                  center={center}
                  zoom={18}
                >
                  <Marker position={center} />
                </GoogleMap>
              ) : (
                <p>Loading Map...</p>
              )}



            </div>
            <hr className='p-0 m-0'></hr>

          </div>
        </div>
      )}



    </div>
  );
};

export default DeliveriesQueue;
